<template>
  <MasterTable
    title="Avställning ansvariga"
    :rows="responsibles"
    :columns="columns"
    :loading="loading"
    :add="add"
    :update="update"
    :remove="remove"
    :reset-form-model="resetFormModel"
    :form-model="model"
    :export-data="exportData"
    remove-item-text-prop="name"
    @update-form-model="(row) => (model = row)"
  >
    <template v-slot:form>
      <div class="row" style="min-width: 300px">
        <div class="col-12 q-pa-md">
          <q-input
            dense
            v-model="model.name"
            label="Depå"
            :rules="[requiredRule]"
          />
        </div>
      </div>
    </template>
  </MasterTable>
</template>

<script lang="ts">
import { defineComponent, computed, ref } from 'vue'
import MasterTable from '@/components/master/MasterTable.vue'
import {
  required as requiredRule,
  booleanTrueRequired,
} from '@/common/formValidationRules'
import { v4 as uuidv4 } from 'uuid'
import { useVehicleWithdrawalResponsible } from '@/composable/useVehicleWithdrawalResponsible'
import { VehicleWithdrawalResponsible } from '@/types/vehicle-withdrawal-responsible'

export default defineComponent({
  name: 'VehicleWithdrawalResponsibles',

  components: {
    MasterTable,
  },

  setup() {
    const {
      loading: loadingState,
      data: responsibles,
      add,
      update,
      remove,
      fetchAll,
    } = useVehicleWithdrawalResponsible()

    fetchAll()

    function createFormModel(): Partial<VehicleWithdrawalResponsible> {
      return {
        uuid: uuidv4(),
        name: '',
      }
    }
    const model = ref<Partial<VehicleWithdrawalResponsible>>(createFormModel())

    function resetFormModel() {
      model.value = createFormModel()
    }

    const columns = [
      {
        name: 'name',
        label: 'Ansvarig',
        align: 'left',
        field: 'name',
        sortable: true,
      },
    ]

    const loading = computed(() => {
      return {
        ...loadingState.value,
      }
    })

    const exportData = computed(() => {
      return responsibles.value.map((responsible) => {
        return {
          Depå: responsible.name,
        }
      })
    })

    return {
      columns,
      model,
      requiredRule,
      booleanTrueRequired,
      responsibles,
      add,
      remove,
      update,
      loading,
      resetFormModel,
      exportData,
    }
  },
})
</script>
